export default "__VITE_ASSET__e4a43793__"